import { Routes } from '@angular/router';
import { CountryResolverServiceService } from '@fitness-force/api';

// We'll keep the existing routes from app-routing.module.ts
// but convert them to the standalone format
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'crm',
    pathMatch: 'full'
  },
  {
    path: 'auth', loadChildren: () => import('./features/auth/auth.module').then(a => a.AuthModule), data: { isTenant: false }
  },
  {
    path: 'backendauth', loadComponent: () => import('./features/auth/callback/auth-callback.component').then(a => a.AuthCallbackComponent), data: { isTenant: false }
  },
  {
    path: 'crm',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/crm/crm.module').then(c => c.CRMModule),
    data: { isTenant: true, breadcrumb: "CRM" }
  },
  {
    path: 'admin',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/admin/admin.module').then(c => c.AdminModule), data: { isTenant: true, breadcrumb: "ADMIN" }
  },
  {
    path: 'enterprise',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/enterprise/enterprise.module').then(c => c.EnterpriseModule), data: { isTenant: true, breadcrumb: "ENTERPRISE" }
  },
  {
    path: 'report', 
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/reports/reports.module').then(c => c.ReportsModule), data: { isTenant: true, breadcrumb: "REPORT" }
  },
  {
    path: 'schedule',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/schedule/schedule.module').then(c => c.ScheduleModule), data: { isTenant: true, breadcrumb: "SCHEDULE" }
  },
  {
    path: 'client',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/client-profile/client-profile.module').then(cp => cp.ClientProfileModule), data: { isTenant: true }
  },
  {
    path: 'client-management',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/client-management/client-management.module').then(cm => cm.ClientManagementModule), data: { isTenant: true }
  },
  {
    path: 'pos',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/pos/pos.module').then(c => c.PosModule), data: { isTenant: true,breadcrumb: "pos"  }
  },
  {
    path: 'signup', 
    loadComponent: () => import('./features/company-sign-up/company-sign-up.component').then(c => c.CompanySignUpComponent)
  },
  {
    path: 'dashboard',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/dashboard/dashboard.module').then(c => c.DashboardModule), data: { isTenant: true, breadcrumb: "CRM" }
  },
  {
    path: 'automation', 
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/automation/automation.module').then(c => c.AutomationModule), data: { isTenant: true,breadcrumb: "AUTOMATION"  }
  },
  {
    path: 'campaign',
    resolve: { CountryResolverServiceService },
    loadChildren: () => import('./features/campaign/campaign.module').then(c => c.CampaignModule), data: { isTenant: true,breadcrumb: "CAMPAIGN"  }
  },
  {
    path: 'unauthorized', loadComponent: () => import('./features/admin/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent), data: { isTenant: true }
  },
  {
    path: 'invoice/:uuid', loadComponent: () => import('./features/invoice/show-invoice/show-invoice.component').then(c => c.ShowInvoiceComponent),data: { type: "Invoice"}
  },
  {
    path: 'sales_return/:uuid', loadComponent: () => import('./features/invoice/show-invoice/show-invoice.component').then(c => c.ShowInvoiceComponent),data: { type: "SalesReturn"}
  },
  {
    path: 'analytics', loadComponent: () => import('./features/analytics/analytics/analytics.component').then(c => c.AnalyticsComponent), data: { isTenant: false, breadcrumb: "ANALYTICS" }
  },
  {
    path: 'company-not-found', loadComponent: () => import('@fitness-force/errors').then(a => a.CompanyNotFoundComponent), data: { isTenant: false }
  },
  {
    path: 'tenant-not-found',
    resolve: { CountryResolverServiceService },
    loadComponent: () => import('./features/admin/tenant-not-found/tenant-not-found.component').then(a => a.TenantNotFoundComponent), data: { isTenant: true }
  },
  {
    path: 'company-login',
    loadChildren: () =>
      import('./features/temp-company-login/temp-company-login.routes').then(
        (m) => m.TempCompanyLoginRoutes
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/page-not-found/page-not-found.routes').then(
        (m) => m.PageNotFoundRoutes
      )
  }
]; 